"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGuestMode = useGuestMode;
const react_1 = require("react");
function useGuestMode() {
    const queryString = window.location.search;
    return (0, react_1.useMemo)(() => {
        const params = new URLSearchParams(queryString);
        return params.get("guest") === "true";
    }, [queryString]);
}
